import React from 'react'

import Text from './Text'

const Paragraph = ({ ...rest }) => <Text as="p" {...rest} />

export default Paragraph
